/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { isIOS } from '@/helper/device'

if (process.env.NODE_ENV === 'production' && !isIOS) {
  console.log('iOS以外でsw登録')
  register('/sw.js', {
    ready () {
      console.info('Service worker is active.')
    },
    registered () {
      console.info('Service worker has been registered.')
    },
    cached () {
      console.info('Content has been cached for offline use.')
    },
    updatefound () {
      console.info('New content is downloading.')
    },
    updated() {
      console.info('New content is available; please refresh.')
      alert('新しいバージョンが見つかりました。「設定」画面の「アプリ更新」をタップしてアプリを更新してください。')
    },
    offline () {
      console.info('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
